import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import enTranslations from './locales/en.json'
import nlTranslations from './locales/nl.json'

const resources = {
	en: {
		translation: enTranslations,
	},
	nl: {
		translation: nlTranslations,
	},
}

export const SUPPORTED_UI_LANGUAGES = Object.keys(resources) as (keyof typeof resources)[]

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'en',
		debug: false,

		// Language detection options
		detection: {
			order: ['localStorage', 'navigator', 'htmlTag'],
			caches: ['localStorage'],
			lookupLocalStorage: 'i18nextLng',
			lookupSessionStorage: 'i18nextLng',
			lookupFromPathIndex: 0,
			lookupFromSubdomainIndex: 0,
			cookieMinutes: 302400,
			cookieDomain: 'localhost',
			cookieOptions: { path: '/', sameSite: 'strict' },
		},

		interpolation: {
			escapeValue: false, // React already does escaping
		},

		// Namespace configuration
		defaultNS: 'translation',
		ns: ['translation'],

		// React i18next options
		react: {
			useSuspense: false, // Disable suspense for better UX
		},

		// Don't set lng explicitly to allow language detection to work
		supportedLngs: SUPPORTED_UI_LANGUAGES,
	})

export default i18n
